import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { Combobox } from '@/components/ui/combobox';
import { trpc } from '@/lib/trpc';

const AUTO = '__auto__';

interface PaymentAccountSelectProps {
  value: string | undefined;
  onChange: (accountId: string | undefined) => void;
  disabled?: boolean;
}

/**
 * Optional kasa/banka/POS account picker for payment forms. Left on "auto",
 * the posting engine resolves the account from the method+currency rules
 * (Entegrasyon Tanımları) as before; picking an account posts there instead.
 */
export function PaymentAccountSelect({ value, onChange, disabled }: PaymentAccountSelectProps) {
  const { t } = useTranslation('accounting');
  const { data: accounts } = trpc.account.listPaymentAccounts.useQuery();

  return (
    <div className="space-y-2">
      <Label>{t('paymentAccountSelect.label', 'Kasa / Banka Hesabı')}</Label>
      <Combobox
        options={[
          {
            value: AUTO,
            label: t('paymentAccountSelect.auto', 'Otomatik (yöntem eşlemesine göre)'),
          },
          ...(accounts ?? []).map((a) => ({
            value: a.id,
            label: `${a.code} · ${a.name}`,
            keywords: [a.code, a.name],
          })),
        ]}
        value={value ?? AUTO}
        onValueChange={(v) => onChange(v === AUTO ? undefined : v)}
        disabled={disabled}
        placeholder={t('paymentAccountSelect.placeholder', 'Hesap seçin')}
        searchPlaceholder={t('paymentAccountSelect.search', 'Kod veya isim ara...')}
      />
      <p className="text-muted-foreground text-xs">
        {t(
          'paymentAccountSelect.help',
          'Boş bırakılırsa hesap, Entegrasyon Tanımları eşlemesinden belirlenir.'
        )}
      </p>
    </div>
  );
}
